import React, { Suspense } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import "./patient-clinical-history.scss";
import ModalHeader from "../../../../@dhn/components/molecules/modal-header";

const AppointmentHistories = React.lazy(
  () => import("../../clinic-history/Appointment-histories"),
);

export default function PatientClinicalHistoryModal({
  isOpen,
  toggle,
  patient,
  profile,
  user,
  center,
  dataDoctor,
}) {
  return (
    <Modal
      isOpen={isOpen}
      centered
      className="custom-modal-dialog patient-clinical-history-modal"
      toggle={toggle}
    >
      <ModalHeader
        toggle={toggle}
        iconClass="fa-history"
        description="Historia clínica del paciente"
        subtitle="Revise las consultas y registros médicos del paciente."
      />
      <ModalBody>
        {isOpen && patient?.id ? (
          <Suspense
            fallback={(
              <div className="d-flex justify-content-center p-5">
                <span className="spinner-border text-primary" />
              </div>
            )}
          >
            <AppointmentHistories
              embedded
              initialPatient={patient}
              {...{ profile, user, center, dataDoctor }}
            />
          </Suspense>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" className="btn-color-danger" onClick={toggle}>
          <i className="fa fa-times" aria-hidden="true" />
          {" Cerrar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
